import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/misc/animation/sun.svg'
import _imports_1 from '@/assets/images/misc/animation/shot.svg'
import _imports_2 from '@/assets/images/misc/animation/machine.svg'
import _imports_3 from '@/assets/images/misc/animation/ways.svg'
import _imports_4 from '@/assets/images/misc/animation/icecoldshot.svg'
import _imports_5 from '@/assets/images/misc/animation/glass-left.svg'
import _imports_6 from '@/assets/images/misc/animation/glass-right.svg'


import DefaultLayout from "../layouts/DefaultLayout.vue";
import ShotAnimationImage from "./ShotAnimationImage.vue";
import { useGlobalStore } from "../stores/global";
import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ShotAnimation',
  setup(__props) {

const globalStore = useGlobalStore();

const moveToGame = () => {
  setTimeout(() => {
    globalStore.changeStep("peopleCheck");
  }, 3700);
};

onMounted(() => {
  moveToGame();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, { "background-image": "green" }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "flex flex-col items-center h-full" }, [
        _createElementVNode("div", { class: "flex-1 flex flex-col justify-center" }, [
          _createElementVNode("div", { class: "relative animation-wrapper" }, [
            _createElementVNode("img", {
              src: _imports_0,
              class: "sun"
            }),
            _createElementVNode("img", {
              src: _imports_1,
              class: "shot"
            }),
            _createElementVNode("img", {
              src: _imports_2,
              class: "machine"
            }),
            _createElementVNode("img", {
              src: _imports_3,
              class: "ways"
            }),
            _createElementVNode("img", {
              src: _imports_4,
              class: "icecoldshot"
            }),
            _createElementVNode("img", {
              src: _imports_5,
              class: "glass-left"
            }),
            _createElementVNode("img", {
              src: _imports_6,
              class: "glass-right"
            })
          ])
        ])
      ], -1)
    ])),
    _: 1
  }))
}
}

})